export default function useRescaleColumns(gridRef, wrapperRef) {
  const rescaleColumns = () => {
    // Scale columns based on header content
    gridRef.current.api.autoSizeAllColumns();

    // Scale up to fit all view if columns smaller than view
    const savedState = gridRef.current.api.getColumnState();
    const colsToFit = savedState.filter(c => c.colId !== 'ag-Grid-SelectionColumn');
    const currTotalWidth = colsToFit.map((c) => c.width).reduce((agg, val) => agg + val, 0);
    const selectionColWidth = (savedState.find(c => c.colId === 'ag-Grid-SelectionColumn')?.width || 0) + 5;

    const scale = (wrapperRef.current.clientWidth - selectionColWidth - 32) / currTotalWidth;
    let accumMod = 0.0;
    if (scale > 1.0){
      colsToFit.forEach((col, idx) => {
        const new_width = col.width * scale + accumMod;
        const int_width = Math.floor(new_width);
        accumMod = new_width - int_width;
        col.width = int_width;
      })
      gridRef.current.api.applyColumnState({state: savedState})
    }
  }

  return rescaleColumns
}